/* eslint-disable import/prefer-default-export */
// Put your reducers in this file.

export const todoApp = (state = localStorage.todos
  ? JSON.parse(localStorage.todos)
  : [], action) => {
  const copyState = [...state];
  const hiddenCards = [];
  let todosPending = [];
  let todosDone;
  let newEditStatus;

  switch (action.type) {
    case 'CREATE_TODO':
      return [...state, action.todo];

    case 'TOGGLE_STATUS':
      if (copyState[action.todoIndex].status === 'pending') {
        copyState.splice(action.todoIndex, 1, { ...copyState[action.todoIndex], status: 'done' });
      } else {
        copyState.splice(action.todoIndex, 1, { ...copyState[action.todoIndex], status: 'pending' });
      }
      return copyState;

    case 'DELETE_TODO':
      copyState.splice(action.todoIndex, 1);
      return copyState;
    case 'SORT_TODOS':
      todosPending = copyState.filter(todo => todo.status === 'pending').sort((a, b) => a.id - b.id);
      todosDone = copyState.filter(todo => todo.status === 'done').sort((a, b) => a.id - b.id);
      return [...todosPending, ...todosDone];
    case 'TOGGLE_HIDE':
      // eslint-disable-next-line array-callback-return
      copyState.map(todo => {
        if (todo.status === 'done' && todo.hidden === false) {
          hiddenCards.push({ ...todo, hidden: true });
          return;
        }
        if (todo.status === 'done' && todo.hidden === true) {
          hiddenCards.push({ ...todo, hidden: false });
          return;
        }
        hiddenCards.push(todo);
      });
      return hiddenCards;
    case 'TOGGLE_EDITMODE':
      newEditStatus = copyState[action.todoIndex].editMode === false;
      copyState.splice(action.todoIndex, 1, {
        ...copyState[action.todoIndex],
        editMode: newEditStatus,
      });
      return copyState;

    case 'UPDATE_TODO':
      copyState.splice(action.todoIndex, 1, action.todo);
      return copyState;
    case 'DELETE_ALL':
      return [];
    case 'DELETE_DONE':
      return copyState.filter(todo => todo.status === 'pending');
    default:
      return state;
  }
};
